import PageHeader from "src/components/pageHeader";
import { RedeemVoucherForm } from "../components/redeem-voucher/redeem-voucher-form";

export const RedeemCreditVoucher = () => {
  return (
    <div className="page_container">
      <PageHeader text="Redeem Credit Voucher" />
      <RedeemVoucherForm />
    </div>
  );
};

